import { render, staticRenderFns } from "./ServeDialog.vue?vue&type=template&id=31eadbed&scoped=true&"
import script from "./ServeDialog.vue?vue&type=script&lang=js&"
export * from "./ServeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eadbed",
  null
  
)

export default component.exports